module.exports = __webpack_public_path__ + "img/web3icon4.0357a053.png";